import { React, useEffect, useState } from 'react';
import { PAGE_ROUTE, API_URL } from '../shared/constant';
import { NavLink, useNavigate } from 'react-router-dom';
import TableComponent from '../../admin/shared/table';
import LoaderComponent from '../../admin/shared/loader';
import axios from 'axios';

export default function CategoryListComponent() {

    const columns = [{
        field: 'name',
        lable: 'Name'
    }, {
        field: 'description',
        lable: 'Description'
    }, {
        field: 'image',
        lable: 'Image'
    }];

    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isRecall, setIsRecall] = useState(false);

    useEffect(() => {
        getCategory();
    }, []);

    useEffect(() => {
        isRecall && getCategory();
    }, [isRecall]);

    const getCategory = () => {
        setLoading(true);
        axios.post(API_URL.ADMIN_CATEGORY_LIST, {}).then(res => {
            setData(res.data.data);
            setIsRecall(false);
            setLoading(false);
        }, error => {
            setLoading(false);
        })
    };

    const onDelete = (item) => {
        let id = item.id;
        axios.post(API_URL.ADMIN_CATEGORY_DELETE + id).then((response) => {
            setIsRecall(true);
        });
    };

    const onEdit = (item) => {
        navigate(PAGE_ROUTE.ADMIN_CATEGORY_EDIT + item.id, { replace: true });
    };

    const updateOrder = (cid, sequence, k) => {
        let cpData = [...data];
        cpData[k].sequence = sequence;
        setData(cpData);
        axios.post(API_URL.ADMIN_CATEGORY_ORDER, { id: cid, sequence: sequence }).then((response) => {
            if (response.data.status === 1) {}
        });
    }

    return (
        <div>
            <div className='card'>
                <div className='card-body'>
                    <h4 className='card-title'>Design
                        <NavLink to={PAGE_ROUTE.ADMIN_CATEGORY_CREATE} className="btn btn-primary">
                            Add
                        </NavLink>
                    </h4>

                    {
                        isLoading && <LoaderComponent height={100} width={100}></LoaderComponent>
                    }
                    {
                        !isLoading && <div className="table-responsive">
                            <div className='table-responsive'>
                                <table className="table table-hover">
                                    <thead className="thead">
                                        <tr>
                                            <th>Name</th>
                                            <th>Home Name</th>
                                            <th>Order</th>
                                            <th>Image</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((element, key) => {
                                            return (
                                                <tr key={key}>
                                                    <td>{element.name}</td>
                                                    <td>{element.home_name}</td>
                                                    <td width={150}>
                                                        <input onChange={(e) => updateOrder(element.id, e.target.value, key)} type='text' value={element.sequence} className='form-control' />
                                                    </td>
                                                    <td><img src={element.image} width="100" height="100" alt="slider_iamges" /></td>
                                                    <td>
                                                        <button type="button" className="btn btn-outline-primary btn-sm me-2" onClick={() => onEdit(element)}>Edit</button>
                                                        <button type="button" className="btn btn-outline-danger btn-sm me-2" onClick={() => onDelete(element)}>Delete</button></td>
                                                </tr>)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}